var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ShowHeader
    ? _c("header", { staticClass: "c-header c-header-light c-header-fixed" }, [
        _c("div", { staticStyle: { width: "50px" } }),
        _c("div", { staticClass: "c-header-nav" }, [
          _vm._v(
            " " +
              _vm._s(_vm.Title) +
              " 目前登入者:" +
              _vm._s(_vm.headerBarInfo) +
              " "
          )
        ]),
        _c("ul", { staticClass: "c-header-nav mfs-auto" }, [
          _c("li", { staticClass: "c-header-nav-item px-3 c-d-legacy-none" }, [
            _c(
              "button",
              {
                staticClass: "c-class-toggler c-header-nav-btn",
                attrs: {
                  type: "button",
                  id: "header-tooltip",
                  "data-target": "body",
                  "data-class": "c-dark-theme",
                  "data-toggle": "c-tooltip",
                  "data-placement": "bottom",
                  title: "Toggle Light/Dark Mode"
                }
              },
              [
                _c("svg", { staticClass: "c-icon c-d-dark-none" }, [
                  _c("use", {
                    attrs: {
                      "xlink:href":
                        "theme/coreUI3/vendors/@coreui/icons/svg/free.svg#cil-moon"
                    }
                  })
                ]),
                _c("svg", { staticClass: "c-icon c-d-default-none" }, [
                  _c("use", {
                    attrs: {
                      "xlink:href":
                        "theme/coreUI3/vendors/@coreui/icons/svg/free.svg#cil-sun"
                    }
                  })
                ])
              ]
            )
          ])
        ]),
        _c("ul", { staticClass: "c-header-nav" }, [
          _c("li", { staticClass: "c-header-nav-item dropdown" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "dropdown-menu dropdown-menu-right pt-0" },
              [
                _c(
                  "a",
                  { staticClass: "dropdown-item", attrs: { href: "/Login" } },
                  [
                    _c("svg", { staticClass: "c-icon mfe-2" }, [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "theme/coreUI3/vendors/@coreui/icons/svg/free.svg#cil-account-logout"
                        }
                      })
                    ]),
                    _vm._v(" 登出")
                  ]
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "c-header-nav-link",
        attrs: {
          "data-toggle": "dropdown",
          href: "#",
          role: "button",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("div", { staticClass: "c-avatar" }, [
          _c("img", {
            staticClass: "c-avatar-img",
            attrs: {
              src: "theme/coreUI3/extra/noun_user avatar_423426.png",
              alt: ""
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }